<div class="new-template">
  <div class="deductible">
    <div class="deductible-type">
      <div class="value">
        <div class="amount" data-cy="coverageDeductibleAmount">
          {{ coverage.deductible.value | currency: 'USD' : 'symbol' : '1.0' }}
        </div>
        <div class="type" data-cy="coverageDeductibleType">
          {{ name }}
        </div>
      </div>
    </div>
  </div>
</div>
